import type { MovementError } from "@features/vessel-call/vessel-call-status/MovementServices/form/utils.ts";
import type { MovementUpdatePayload } from "@services/movement-services/types";
import { updateMovementById } from "@services/movementServicesApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useUpdateMovement = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: () => void;
  handleError: (error: MovementError) => void;
}) => {
  const updateMovementMutation = useMutation({
    mutationFn: (variables: Parameters<typeof updateMovementById>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "MovementService",
          action: "update_movement_service",
          entityType: "movement_service",
        },
        (transactionId) =>
          updateMovementById({ ...variables, ...(transactionId ? { transactionId } : {}) }),
      ),
    onSuccess: () => handleSuccess(),
    onError: (error: MovementError) => handleError(error),
  });

  const updateMovement = async ({
    id,
    service,
    payload,
  }: {
    id: string;
    service: string;
    payload: MovementUpdatePayload;
  }) => {
    updateMovementMutation.mutate({
      id,
      service,
      payload,
    });
  };

  return {
    updateMovement,
  };
};
